import React from "react";

/**
 * Classic three-lobed biohazard mark for Atomic Client Destruction.
 * Fill via currentColor (hazard yellow from CSS). Not Unicode/emoji.
 *
 * Geometry: three annular lobes at 120° around a center disk —
 * the CDC / ISO biohazard silhouette (not radiation/atom).
 */
export function BiohazardMark({
  className = "",
  size = 24,
  decorative = true,
  title = "Biohazard",
}) {
  const ariaProps = decorative
    ? { "aria-hidden": true, role: "presentation" }
    : { role: "img", "aria-label": title };

  return (
    <svg
      className={`cbr-biohazard ${className}`.trim()}
      width={size}
      height={size}
      viewBox="0 0 64 64"
      fill="currentColor"
      focusable="false"
      {...ariaProps}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d={BIOHAZARD_PATH}
      />
    </svg>
  );
}

/**
 * Single compound path — three hollow lobes + nucleus.
 * Lobes centered at (32,18), (44.2,39), (19.8,39); outer r≈13.5, inner r≈6.
 */
const BIOHAZARD_PATH = [
  // Top outer + inner
  "M18.5 18c0-7.456 6.044-13.5 13.5-13.5S45.5 10.544 45.5 18 39.456 31.5 32 31.5 18.5 25.456 18.5 18z",
  "M26 18c0-3.314 2.686-6 6-6s6 2.686 6 6-2.686 6-6 6-6-2.686-6-6z",
  // Bottom-right outer + inner
  "M30.7 39c0-7.456 6.044-13.5 13.5-13.5S57.7 31.544 57.7 39s-6.044 13.5-13.5 13.5S30.7 46.456 30.7 39z",
  "M38.2 39c0-3.314 2.686-6 6-6s6 2.686 6 6-2.686 6-6 6-6-2.686-6-6z",
  // Bottom-left outer + inner
  "M6.3 39c0-7.456 6.044-13.5 13.5-13.5S33.3 31.544 33.3 39s-6.044 13.5-13.5 13.5S6.3 46.456 6.3 39z",
  "M13.8 39c0-3.314 2.686-6 6-6s6 2.686 6 6-2.686 6-6 6-6-2.686-6-6z",
  // Nucleus
  "M28 32c0-2.21 1.79-4 4-4s4 1.79 4 4-1.79 4-4 4-4-1.79-4-4z",
].join("");

export default BiohazardMark;
